export class EvidenceBundlesIntegration {
    constructor(service, getTenantKey) {
        this.service = service;
        this.getTenantKey = getTenantKey;
    }

    async request(operation) {
        const tenantKey = String(this.getTenantKey() ?? '');
        try {
            const result = await operation();
            if (String(this.getTenantKey() ?? '') !== tenantKey) return { success: false, stale: true };
            return result;
        } catch (error) {
            if (String(this.getTenantKey() ?? '') !== tenantKey) return { success: false, stale: true };
            return { success: false, error: error?.message || 'Evidence bundle request failed', code: error?.code };
        }
    }

    list(entityType, entityId) {
        return this.request(() => this.service.list(entityType, entityId));
    }

    getById(id) {
        return this.request(() => this.service.getById(id));
    }

    create(input) {
        return this.request(() => this.service.create(input));
    }

    seal(id) {
        return this.request(() => this.service.seal(id));
    }

    export(id, format) {
        return this.request(() => this.service.export(id, format));
    }
}
